
import { alpha, debounce, Grid, InputBase, styled } from "@mui/material";
import { useState } from "react";
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close';
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import { setProductParams } from "./catalogSlice";
import { useNavigate } from "react-router-dom";

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.black, 0.05),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.black, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      
      [theme.breakpoints.up('sm')]: {
        width: '20ch',
        '&:focus': {
          width: '20ch',
        },
      },
    },
}));

export default function ProductSearch() {
  
    const [anchorElSearch, setAnchorElSearch] = useState(false);
    const handleSearchIconClick = () => {
      setAnchorElSearch(!anchorElSearch);
    };
    const {productParams} = useAppSelector(state => state.catalog)
    const [searchTerm, setSearchTerm] = useState(productParams.searchTerm)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const debounceSearch = debounce((event: any) => {
        dispatch(setProductParams({searchTerm: event.target.value}))
        navigate("/catalog")}, 1000) // make the get API delayed and redirect to catalog page

    return (
      <>
          <Search sx={{display: { xs: 'none', md: 'flex' }}}>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search…"
              inputProps={{ 'aria-label': 'search' }}
              value={searchTerm || ''}
              onChange={(event:any) => {
                  setSearchTerm(event.target.value)
                  debounceSearch(event)

                }}
            />
          </Search>
          
          {!anchorElSearch && <SearchIcon sx={{display: { xs: 'flex', md: 'none' }}} onClick={handleSearchIconClick}/>}
          
          {anchorElSearch && 
          <Grid container sx={{display: { xs: 'flex', md: 'none' }}}>
              <Grid item xs={11}>
                  <Search >
                      <SearchIconWrapper>
                          <SearchIcon/>
                      </SearchIconWrapper>
                      <StyledInputBase
                      placeholder="Search…"
                      inputProps={{ 'aria-label': 'search' }}
                      value={searchTerm || ''}
                      onChange={(event:any) => {
                          setSearchTerm(event.target.value)
                          debounceSearch(event)
                      }}
                      />
                  </Search>
              </Grid>
              <Grid item xs={1} >
                  <CloseIcon onClick={handleSearchIconClick} sx={{position: "absolute", top: '30%'}} />
              </Grid>
          </Grid>
          }
        </>
     
    )
}